<template>
  <div>
    <DatePicker
      v-model="searchDate"
      type="daterange"
      placement="bottom-end"
      placeholder="选择时间"
      style="width: 200px"
    ></DatePicker>

    <Button type="primary" @click="selmachine">查询</Button>
    <Table :columns="columns10" :data="data9"> </Table>
  </div>
</template>
<script>
import SingleUpload from "@/components/Upload/singleUpload";
import { mgclist } from "../../api/finance";

const OSS = require("ali-oss");
var ossClient = null;
export default {
  components: { SingleUpload },
  data() {
    return {
      modal3: false,
      searchDate: [],
      fengmian: "", //封面图
      guize: "", //规则图
      roomlv: "", //房间等级
      jiqihao: "", //机器号
      duankouhao: "", //端口号
      roomname: "", //房间名称
      danjia: "", //单价
      jiangli: "", //奖励
      wawatime: "10", //询奖时间
      wintishi: "否", //中奖是否发维护信息
      loading: true,
      modal1: false,
      xbid: "", //小板id
      xbsort: 1, //小板座位号
      clickmachineid: "",
      videourl1: "",
      videourl2: "",
      columns10: [
        {
          title: "房间id",
          key: "roomid",
        },
        {
          title: "房间名称",
          key: "roomname",
        },
        {
          title: "机器类型",
          key: "machinetype",
          render: (h, params) => {
            var machinetype =
              params.row.machinetype == "0" ? "魔鬼城" : "游戏机";
            return h("span", machinetype);
          },
        },
        {
          title: "投币数",
          key: "total_coinnumber",
          sortable: true,
          sortMethod: (a, b, type) => {
            const na = Number(a || 0);
            const nb = Number(b || 0);
            return type === "desc" ? nb - na : na - nb;
          },
        },

        {
          title: "出币数",
          key: "total_wincoin",
        },
        {
          title: "产出礼品数",
          key: "total_wingiftnum",
        },
        {
          title: "产出礼品兑换币数",
          key: "total_goods_coin_value",
        },
        {
          title: "总产出",
          key: "convertedWinCoin",
           
        },
        {
          title: "利润",
          key: "profit",
          sortable: true,
          sortMethod: (a, b, type) => {
            const na = Number(a || 0);
            const nb = Number(b || 0);
            return type === "desc" ? nb - na : na - nb;
          },
           
        },
        {
          title: "利润率",
          key: "profitRate",
           
        },
      ],
      data9: [],
    };
  },
  mounted() {
    this.selmachine();
  },
  methods: {
    formatDate(date) {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const day = String(date.getDate()).padStart(2, "0");

      return `${year}-${month}-${day}`;
    },

    selmachine() {
      var starttime = "";
      var endtime = "";
      if (this.searchDate.length > 0 && this.searchDate[0] != "") {
        starttime = this.formatDate(this.searchDate[0]);
        endtime = this.formatDate(this.searchDate[1]);
      }
      const params = {
        starttime,
        endtime,
      };

      mgclist(params).then((res) => {
        console.log("===" + JSON.stringify(res));

        this.data9 = res.data;
      });
    },
    updateimage1(value) {
      this.fengmian = value;
      console.log("updateimage1" + value);
    },
    updateimage2(value) {
      this.guize = value;
      console.log("updateimage2" + value);
    },

    cancel() {
      this.$Message.info("Clicked cancel");
    },
    updateMachineStatus(status) {
      updateMachineStatus({ status: status, roomid: this.clickmachineid }).then(
        (res) => {
          this.selmachine();
        }
      );
    },
    guanbimodal() {
      this.modal3 = false;
    },
  },
};
</script>
